// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.0faf11e81.chunk.js";
	if (chunkId === 12) return "static/js/profiler.0faf11e81.chunk.js";
	if (chunkId === 502) return "static/js/502.0faf11e81.chunk.js";
	if (chunkId === 48) return "static/js/48.0faf11e81.chunk.js";
	if (chunkId === 196) return "static/js/196.0faf11e81.chunk.js";
	if (chunkId === 386) return "static/js/386.0faf11e81.chunk.js";
	if (chunkId === 315) return "static/js/315.0faf11e81.chunk.js";
	if (chunkId === 631) return "static/js/631.0faf11e81.chunk.js";
	if (chunkId === 848) return "static/js/848.0faf11e81.chunk.js";
	if (chunkId === 492) return "static/js/492.0faf11e81.chunk.js";
	if (chunkId === 564) return "static/js/564.0faf11e81.chunk.js";
	if (chunkId === 591) return "static/js/591.0faf11e81.chunk.js";
	if (chunkId === 852) return "static/js/852.0faf11e81.chunk.js";
	if (chunkId === 659) return "static/js/659.0faf11e81.chunk.js";
	if (chunkId === 700) return "static/js/700.0faf11e81.chunk.js";
	if (chunkId === 449) return "static/js/449.0faf11e81.chunk.js";
	if (chunkId === 372) return "static/js/372.0faf11e81.chunk.js";
	if (chunkId === 925) return "static/js/925.0faf11e81.chunk.js";
	if (chunkId === 429) return "static/js/429.0faf11e81.chunk.js";
	if (chunkId === 956) return "static/js/956.0faf11e81.chunk.js";
	if (chunkId === 402) return "static/js/402.0faf11e81.chunk.js";
	// return url for filenames based on template
	return undefined;
};